import { AxiosInstance } from 'axios'

import { User } from '@dc-shared-web/hooks/api/user'
import { BasicTeam } from '@dc-shared-web/hooks/api/team'

export type GetTeamsSelectOptionsParams = {
  p: number
  pp: number
  q?: string
}

export type GetTeamsSelectOptionsResponse = {
  teams: BasicTeam[]
  hasMore: boolean
}

export const getTeamSelectOptions = async (
  apiClient: AxiosInstance,
  user: User,
  params: GetTeamsSelectOptionsParams
): Promise<GetTeamsSelectOptionsResponse> => {
  if (!user.is_super_admin) {
    return {
      teams: user.teams
        .filter((t) =>
          params.q
            ? t.name.toLowerCase().includes(params.q.toLowerCase())
            : true
        )
        .sort((teamA, teamB) => teamA.name.localeCompare(teamB.name))
        .map((t) => ({
          uuid: t.id,
          id: t.teamId,
          text: t.name,
          isAdmin: t.is_admin,
          customer_id: t.customer_id,
        })),
      hasMore: false,
    }
  }

  const { data } = await apiClient.get('/ajax/offices/find', {
    params,
  })

  return {
    teams: data.results,
    hasMore: data.pagination.more ?? false,
  }
}
